import { render } from "./Ogpo.vue?vue&type=template&id=4ebb5438"
import script from "./Ogpo.vue?vue&type=script&lang=js"
export * from "./Ogpo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__